module.exports = __webpack_public_path__ + "media/images/qr/andrew-116c38d594744009aa59db6f102150bc.svg";